import { STATUS_LABELS } from "@/lib/format";

const STYLES = {
  draft: "bg-slate-100 text-slate-800 border-slate-300",
  submitted: "bg-blue-100 text-blue-800 border-blue-300",
  manager_reviewed: "bg-amber-100 text-amber-900 border-amber-300",
  accountant_approved: "bg-emerald-100 text-emerald-900 border-emerald-300",
  locked: "bg-indigo-950 text-white border-indigo-900",
};

export function StatusBadge({ status, className = "" }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STYLES[status] || STYLES.draft} ${className}`}
    >
      {status === "locked" && <span className="h-1.5 w-1.5 rounded-full bg-white" />}
      {STATUS_LABELS[status] || status}
    </span>
  );
}

const VAR_STYLES = {
  within: "bg-emerald-100 text-emerald-800 border-emerald-200",
  warning: "bg-amber-100 text-amber-800 border-amber-200",
  critical: "bg-rose-100 text-rose-800 border-rose-200",
};

export function VarianceBadge({ status, children, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 font-mono-fin text-xs font-semibold ${VAR_STYLES[status] || VAR_STYLES.within}`}
    >
      {children}
    </span>
  );
}
